"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _ButtonGroupOption = _interopRequireDefault(require("./ButtonGroupOption"));

var _excluded = ["name", "value", "options", "disabled", "size", "onChange", "variant"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// Setting a transform here creates a stacking context, so the we can use z-index
// in ButtonGroupOption without worrying about z-index conflicts with other components
var ButtonGroupWrapper = ( /*#__PURE__*/0, _styledBase["default"])(_Flex["default"], {
  target: "esu5jem0",
  label: "ButtonGroupWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "41q668",
  styles: "transform:scale(1);"
} : {
  name: "41q668",
  styles: "transform:scale(1);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var ButtonGroup = function ButtonGroup(_ref) {
  var name = _ref.name,
      value = _ref.value,
      options = _ref.options,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'base' : _ref$size,
      onChange = _ref.onChange,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ButtonGroupWrapper, (0, _extends2["default"])({
    role: "radiogroup",
    "aria-label": name
  }, rest), options.map(function (option, index) {
    var _option$disabled;

    return /*#__PURE__*/_react["default"].createElement(_ButtonGroupOption["default"], {
      key: index,
      id: "buttonGroup_".concat(name, "_").concat(index),
      name: name,
      label: option.label,
      value: option.value,
      checked: option.value === value,
      disabled: disabled || ((_option$disabled = option.disabled) !== null && _option$disabled !== void 0 ? _option$disabled : false),
      size: size,
      totalOptions: options.length,
      onChange: onChange,
      variant: variant
    });
  }));
};

ButtonGroup.propTypes = {
  name: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].node.isRequired,
    value: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool
  })).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
  variant: _propTypes["default"].string
};
var _default = ButtonGroup;
exports["default"] = _default;